import { ReactElement, useRef } from 'react';
import { alpha, Chip, Stack, Tooltip } from '@rossum/ui/material';
import { PartyLabelChip } from './PartyLabelChip';

const CHIP_MAX_WIDTH = 240;

export type LabelChipProps = {
  name: string;
  color?: string | null;
  disabled?: boolean;
  onDelete?: () => void;
  deleteIcon?: ReactElement;
};

export const LabelChip = ({
  name,
  color,
  disabled,
  onDelete,
  deleteIcon,
}: LabelChipProps) => {
  const chipEl = useRef<HTMLDivElement>(null);

  const shouldRenderTooltip = chipEl.current
    ? chipEl.current.clientWidth >= CHIP_MAX_WIDTH
    : false;

  return (
    <Tooltip
      placement="top"
      title={shouldRenderTooltip ? name : ''}
      enterDelay={600}
    >
      <Stack ref={chipEl} sx={{ maxWidth: CHIP_MAX_WIDTH }}>
        {color === 'party' ? (
          <PartyLabelChip
            name={name}
            onDelete={onDelete}
            deleteIcon={deleteIcon}
          />
        ) : (
          <Chip
            label={name}
            onDelete={onDelete}
            deleteIcon={deleteIcon}
            sx={
              color && !disabled
                ? {
                    backgroundColor: alpha(color, 0.35),
                    borderColor: alpha(color, 1),
                  }
                : undefined
            }
          />
        )}
      </Stack>
    </Tooltip>
  );
};
